export default {
    actions: {
        'everything-up-to-date': 'Alle Daten sind gespeichert.',
        save: 'Speichern',
    },
    errors: {
        saving: 'Speichern fehlgeschlagen',
    },
    'bkp-distribution': {
        title: 'BKP Umverteilungs Einstellungen',
        level: 'Level {{level}}',
        regulation: {
            type: {
                node: 'Node',
                leaf: 'Leaf',
            },
        },
        columns: {
            code: 'Code',
            level: 'Level',
            description: 'Beschreibung',
            type: 'Type',
            percentage: 'Umverteilung in Prozent',
        },
    },
};
